<template>
    <div :class="['container', specificClassName, {active: isActive}]"
         @click="activeInput">
        <span :class="iconClassName"
              @click="findByValue"/>
        <input v-model="value"
               ref="input"
               :placeholder="placeholder"
               @blur="closeOnWindowClick($event)"
               @keyup.enter="findByValue"
        />
    </div>
</template>

<script>
    import UniversalModal from "./UniversalModal";

    export default {
        name: "SearchInput",
        components: {UniversalModal},
        props: ['iconClassName', 'placeholder', 'specificClassName', 'isModalVisible'],
        data() {
            return {
                isActive: false,
                value: '',
            }
        },
        methods: {

            closeOnWindowClick(e) {
                let target = e.target;

                while (target instanceof Element) {

                    if (target.classList.contains(this.specificClassName) ||
                        target.classList.contains(this.iconClassName)) {
                        return;
                    }

                    target = target.parentNode;
                }

                this.isModalVisible ? this.isActive = false : '';
                this.value = "";
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            activeInput() {
                this.isActive = true;
            },

            findByValue() {
                if (this.isActive) {
                    this.$store.state.offerSearchQuery = this.value;
                    this.$router.push({path: `/offers?search=${this.value}`}).catch((err)=>{});
                }
            },

            emitData() {
                this.$parent.$emit('searchData', {
                    value: this.value,
                });
            },

            emitShowModal() {
                this.isActive = false;
                this.$parent.$emit('showModal');
            }
        },

        mounted() {
            window.addEventListener('click', this.closeOnWindowClick.bind(this));

            this.$parent.$on('getSearchData', () => {
                this.emitData();
            });
        },

        beforeDestroy() {
            window.removeEventListener('click', this.closeOnWindowClick.bind(this));
        }
    }
</script>
